import service from '@/plugins/request_union'

export const getUnionGame = (params) => {
    return service({
        url: 'app/game/getGame',
        method: 'get',
        params,
        hideErrMsg: true
    })
}